@switch (headingNodeType()) {
  @case ('h1') {
    <h1 class="mb-3 h5 no-hyphenate">
      @if (iconClass()) {
        <i class="fas {{ iconClass() }} mr-1" aria-hidden="true"></i>
      }
      {{ cardTitle() | translate: cardTitleParams() }}
    </h1>
  }
  @case ('h2') {
    <h2 class="mb-3 h5 no-hyphenate">
      @if (iconClass()) {
        <i class="fas {{ iconClass() }} mr-1" aria-hidden="true"></i>
      }
      {{ cardTitle() | translate: cardTitleParams() }}
    </h2>
  }
  @case ('h3') {
    <h3 class="mb-3 h5 no-hyphenate">
      @if (iconClass()) {
        <i class="fas {{ iconClass() }} mr-1" aria-hidden="true"></i>
      }
      {{ cardTitle() | translate: cardTitleParams() }}
    </h3>
  }
  @case ('h4') {
    <h4 class="mb-3 h5 no-hyphenate">
      @if (iconClass()) {
        <i class="fas {{ iconClass() }} mr-1" aria-hidden="true"></i>
      }
      {{ cardTitle() | translate: cardTitleParams() }}
    </h4>
  }
  @case ('h5') {
    <h5 class="mb-3 h5 no-hyphenate">
      @if (iconClass()) {
        <i class="fas {{ iconClass() }} mr-1" aria-hidden="true"></i>
      }
      {{ cardTitle() | translate: cardTitleParams() }}
    </h5>
  }
  @case ('h6') {
    <h6 class="mb-3 h5 no-hyphenate">
      @if (iconClass()) {
        <i class="fas {{ iconClass() }} mr-1" aria-hidden="true"></i>
      }
      {{ cardTitle() | translate: cardTitleParams() }}
    </h6>
  }
  @case ('p') {
    <p class="mb-3 h5 no-hyphenate">
      @if (iconClass()) {
        <i class="fas {{ iconClass() }} mr-1" aria-hidden="true"></i>
      }
      {{ cardTitle() | translate: cardTitleParams() }}
    </p>
  }
}
